import { Component, OnInit } from '@angular/core';
import { NecLoadingConfig } from '../../loading/loading-config';
import { NecLoadingService } from '../../loading/loading.service';
import { NecXiaoXiangInterface } from './xiao-xiang.interface';

@Component({
  templateUrl: './xiao-xiang.component.html',
  styleUrls: ['./xiao-xiang.component.scss']
})
export class NecXiaoXiangComponent implements OnInit {
  loading: NecLoadingConfig;
  contents: any[];
  remainOpenings = 40;
  defaultCount: number[] = [148, 150, 166, 168, 168, 187, 199, 208, 232, 263, 282, 289, 290,
    331, 345, 356, 374, 409, 455, 466, 471, 477, 492, 494, 544, 547, 586, 595, 606, 704, 731,
    850, 935, 1011, 1020, 1033, 1036, 1051, 1077, 1094];


  constructor(private xiaoXiangInterface: NecXiaoXiangInterface, private loadingService: NecLoadingService) {
    this.loading = loadingService.getNecLoadingConfig();
  }

  ngOnInit(): void {
    this.loading.busy = this.xiaoXiangInterface.getXiaoXiangCourses().subscribe((resp: any[]) => {
      resp.sort(function (a, b) {
        return a.activity.id - b.activity.id;
      });
      resp.forEach(content => {
        if (!content.activity.cover && content.activity.defaultCover) {
          switch (content.activity.defaultCover) {
            case 1:
              content.coverImgSrc = 'assets/images/common/home/activity/course-cover1.png';
              break;
            case 2:
              content.coverImgSrc = 'assets/images/common/home/activity/course-cover2.png';
              break;
            case 3:
              content.coverImgSrc = 'assets/images/common/home/activity/course-cover3.png';
              break;
            case 4:
              content.coverImgSrc = 'assets/images/common/home/activity/course-cover4.png';
              break;
            case 5:
              content.coverImgSrc = 'assets/images/common/home/activity/course-cover5.png';
              break;
            default:
              content.coverImgSrc = 'assets/images/common/home/activity/course-cover1.png';
          }
        }
        else {
          if (!content.activity.cover) {
            content.coverImgSrc = 'assets/images/common/home/activity/course-cover1.png';
          }
          else {
            content.coverImgSrc = content.activity.cover.url;
          }
        }
        if (content.activity.state === 'FINISHED') {
          content.activity.reminderText = 'å·²ç»æ';
          content.activity.reminderClass = 'finished';
          return;
        }
        let curTime = new Date().getTime();
        if (curTime > content.activity.startTime) {
          content.activity.reminderText = this.getTime(content.activity.endTime) + 'åç»æ';
          if (this.remainOpenings > 0) {
            content.activity.opening = true;
            content.basicCount = this.defaultCount[this.remainOpenings - 1];
            content.learningPersonCount = this.defaultCount[this.remainOpenings - 1] + content.participatorCount;
            this.remainOpenings--;
          }
          else {
            content.activity.opening = true;
            content.basicCount = 10;
            content.learningPersonCount = content.basicCount + content.participatorCount;
          }
        }
        else {
          let startTime = new Date(content.activity.startTime);
          let month = startTime.getMonth() + 1;
          let day = startTime.getDate();
          content.activity.reminderText = month + 'æ' + day + 'å·å¼å§';
          content.activity.reminderClass = 'unstart';
        }
      });
      this.contents = resp;
    });
  }

  private getTime(finishTime) {
    let nowTime = new Date().getTime();
    let differTime: any = Math.abs(finishTime - nowTime) / 1000;
    if (differTime < 60) {
      differTime = parseInt(differTime, 10) + 'ç§';
    }
    else if (Math.floor(differTime / 60) < 60) {
      differTime = Math.floor(differTime / 60) + 'åé';
    }
    else if (Math.floor(differTime / 3600) < 24) {
      differTime = Math.floor(differTime / 3600) + 'å°æ¶';
    }
    else if (Math.floor(differTime / (3600 * 24)) < 31) {
      differTime = Math.floor(differTime / (3600 * 24)) + 'å¤©';
    }
    else if (Math.floor(differTime / (3600 * 24 * 31)) < 12) {
      let dayTime = Math.floor((differTime -
        Math.floor(differTime / (3600 * 24 * 31)) * 3600 * 24 * 31) / (3600 * 24));
      differTime = Math.floor(differTime / (3600 * 24 * 31)) + 'ä¸ªæ';
      if (dayTime !== 0) {
        differTime += dayTime + 'å¤©';
      }
    } else {
      differTime = Math.floor(differTime / (3600 * 24 * 31 * 12)) + 'å¹´';
    }
    return differTime;
  }

}
